import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    wrapper: {
        marginTop: spacing(3)
    }
}));

interface IButtonProps {
    Testo: string;
    OnClick: () => void;
    Default?: boolean;
    Attivo?: boolean;
    Icona?: React.ReactNode;
    WithWrapper?: boolean;
}

export const _Button: React.FC<IButtonProps> = ({ Testo, OnClick, Default, Attivo, Icona, WithWrapper }) => {
    const classes = useStyles();

    return (
        <Button
            fullWidth
            onClick={e => {
                e.preventDefault();
                OnClick();
            }}
            variant={Default ? "contained" : "outlined"}
            color={Default ? "secondary" : "primary"}
            type={Default ? "submit" : "button"}
            disabled={Attivo != undefined ? !Attivo : false}
            startIcon={Icona}
            className={clsx(WithWrapper && classes.wrapper)}
        >
            {Testo}
        </Button>
    );
};

_Button.defaultProps = {
    Default: true,
    Attivo: true,
    WithWrapper: true
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/Button.tsx